import seoProductsCategoriesUrls from "../../static/seoProductsCategoriesUrls.json"

export function renderLinkList(url: string, shortTitle?: string) {
  if (shortTitle) {
    if (
      url === "https://halvacard.ru/order/credit-card/" ||
      url === "https://halvacard.ru/order/debet-cards/" ||
      url === "https://halvacard.ru/order/zaimy/"
    ) {
      return [
        { url: "https://halvacard.ru", shortTitle: "Главная" },
        { url, shortTitle },
      ]
    }

    if (seoProductsCategoriesUrls.includes(url)) {
      return [
        { url: "https://halvacard.ru", shortTitle: "Главная" },
        {
          url: "https://halvacard.ru/cards/main/halva",
          shortTitle: "Халва",
        },
        { url, shortTitle },
      ]
    }

    if (url.includes("/refinansirovanie-kreditnoy-karty/")) {
      return [
        { url: "https://halvacard.ru", shortTitle: "Главная" },
        {
          url: "https://halvacard.ru/cards/main/halva",
          shortTitle: "Халва",
        },
        { url, shortTitle },
      ]
    }

    if (url.includes("/credit-card/")) {
      return [
        { url: "https://halvacard.ru", shortTitle: "Главная" },
        { url: "https://halvacard.ru/order/credit-card/", shortTitle: "Кредитные карты" },
        { url, shortTitle },
      ]
    }

    if (url.includes("/debet-cards/")) {
      return [
        { url: "https://halvacard.ru", shortTitle: "Главная" },
        { url: "https://halvacard.ru/order/debet-cards/", shortTitle: "Дебетовые карты" },
        { url, shortTitle },
      ]
    }

    if (url.includes("/zaimy/")) {
      return [
        { url: "https://halvacard.ru", shortTitle: "Главная" },
        { url: "https://halvacard.ru/order/zaimy/", shortTitle: "Займы" },
        { url, shortTitle },
      ]
    }

    if (url.includes("/nakopitelnye-scheta/")) {
      return [
        { url: "https://scb.ru", shortTitle: "Главная" },
        {
          url: "https://scb.ru/apply/nakopitelnye-scheta/",
          shortTitle: "Накопительный счёт",
        },
        { url, shortTitle },
      ]
    }

    if (url.includes("/halva/")) {
      return [
        { url: "https://halvacard.ru", shortTitle: "Главная" },
        {
          url: "https://halvacard.ru/halva",
          shortTitle: "Халва",
        },
        { url, shortTitle },
      ]
    }

    if (url.includes("/apply/cards/credit")) {
      return [
        { url: "https://scb.ru/", shortTitle: "Главная" },
        {
          url: "https://scb.ru/cards/credit-cards",
          shortTitle: "Кредитные карты",
        },
        { url, shortTitle },
      ]
    }
  }
  return undefined
}
